var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#icon-dot-976db';
                    var viewUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#view-icon-dot-976db';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 3 3',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };